export const GET_PARAM = 'GET_PARAM';
export const GET_PARAM_SUCCESS = 'GET_PARAM_SUCCESS';
export const GET_PARAM_ERROR = 'GET_PARAM_ERROR';
